var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderSkinOther(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder_skin_other") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "placeholder_skin_other",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#FFA367",
    transform: "translate(50.000000, 50.000000) rotate(-270.000000) translate(-50.000000, -50.000000) ",
    x: 19,
    y: 2.5,
    width: 62,
    height: 95,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#979797",
    fill: "#FFA367",
    transform: "translate(50.500000, 50.000000) rotate(-270.000000) translate(-50.500000, -50.000000) ",
    x: 33,
    y: 32.5,
    width: 35,
    height: 35,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7113821,68 L86.7113821,66.8239845 C86.803523,66.205029 87.0281165,65.6892328 87.3851626,65.2765957 C87.7422087,64.8639587 88.151084,64.4977434 88.6117886,64.1779497 C89.0724932,63.858156 89.5619919,63.5383623 90.0802846,63.2185687 C90.5985772,62.898775 91.0707995,62.5119278 91.4969512,62.0580271 C91.923103,61.6041264 92.2801491,61.0573823 92.5680894,60.417795 C92.8560298,59.7782076 93,58.9632495 93,57.9729207 C93,57.374597 92.8560298,56.7298517 92.5680894,56.0386847 C92.2801491,55.3475177 91.802168,54.7027724 91.1341463,54.1044487 C90.4661247,53.5061251 89.5850271,53.0058027 88.4908537,52.6034816 C87.3966802,52.2011605 86.0318428,52 84.3963415,52 C83.1294038,52 81.9834011,52.1908446 80.9583333,52.5725338 C79.9332656,52.9542231 79.0579268,53.4854932 78.3323171,54.1663443 C77.6067073,54.8471954 77.0423442,55.6518375 76.6392276,56.5802708 C76.2361111,57.5087041 76.0230352,58.5299807 76,59.6441006 L81.0792683,59.6441006 C81.0792683,59.0870406 81.148374,58.5660864 81.2865854,58.0812379 C81.4247967,57.5963894 81.6378726,57.1734365 81.925813,56.8123791 C82.2137534,56.4513217 82.5823171,56.1624758 83.0315041,55.9458414 C83.4806911,55.729207 84.0162602,55.6208897 84.6382114,55.6208897 C85.5596206,55.6208897 86.2794715,55.8478401 86.7977642,56.3017408 C87.3160569,56.7556415 87.5752033,57.4571244 87.5752033,58.4061896 C87.5982385,58.9632495 87.4888211,59.4274662 87.2469512,59.7988395 C87.0050813,60.1702128 86.6883469,60.5106383 86.296748,60.8201161 C85.9051491,61.1295938 85.4789973,61.4390716 85.0182927,61.7485493 C84.5575881,62.0580271 84.1199187,62.4242424 83.7052846,62.8471954 C83.2906504,63.2701483 82.9278455,63.7807866 82.6168699,64.3791103 C82.3058943,64.9774339 82.1158537,65.7201805 82.046748,66.6073501 L82.046748,68 L86.7113821,68 Z M87,76 L87,70 L82,70 L82,76 L87,76 Z",
    id: "?",
    fillOpacity: 0.221345061,
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderSkinOther);
export default __webpack_public_path__ + "static/media/placeholder_skin_other.833d00b6eab975bf285777a62b80849f.svg";
export { ForwardRef as ReactComponent };